<template>
  <div class="background_gray" style="width: 100%; background-color: #3D4A6D;">
    <VContainer fluid class="secondary">
      <!-- DESKTOP -->
      <div class="d-none d-lg-block">
        <VRow>
          <VCol cols="12" md="6">
            <VCol cols="12">
              <VCard class="elevation-0" color="transparent">
                <VCardTitle class="text-h5 font-weight-black">
                  {{ $t('HOME.title') }}
                </VCardTitle>

                <VCardText class="font-weight-light text-h6 mb-16" style="white-space: pre-line;">
                  <span class="text-justify text-white">{{ $t('HOME.description') }}</span>
                </VCardText>

                <VCardActions class="mt-n16">
                  <v-btn
                    color="warning"
                    variant="flat"
                    style="color: white !important;"
                    @click="$emit('start_free')"
                    >
                    {{ $t('HOME.btn_gratis') }}
                </v-btn>

                  <VBtn color="warning" variant="outlined" @click="knowMore">
                    {{ $t('HOME.btn_saber_mais') }}
                  </VBtn>
                </VCardActions>
              </VCard>
            </VCol>

            <!-- DESKTOP -->
            <VCol cols="12" md="8" lg="8" xl="8" class="mt-6">
              <VCard class="elevation-0" color="transparent" :rounded="0">
                <VCardText>
                  <VCarousel
                    :show-arrows="false"
                    :cycle="true"
                    hide-delimiter-background
                    height="250"                 
                  >
                    <VCarouselItem v-for="(item, i) in items" :key="i">
                      <VImg :src="item.src" height="220" contain />  
                    </VCarouselItem>
                  </VCarousel>
                </VCardText>
              </VCard>
            </VCol>

            <VCol cols="12">
              <VCard class="elevation-0" color="transparent" :rounded="0">
                <VCardText class="text-h5 font-weight-bold text-accent">
                  {{ $t('HOME.designed_for') }}
                </VCardText>
              </VCard>
            </VCol>
          </VCol>

          <VCol cols="12" md="6">
            <VImg
              :src="heroImage"
              class="object-contain"
              style="width: 100%; height: auto;"
            />
          </VCol>
        </VRow>
      </div>

      <!-- MOBILE -->
      <VRow class="secondary d-md-none">
        <VCol cols="12" md="6">
          <VCol cols="12">
            <VCard class="elevation-0" color="transparent">
              <VCardTitle class="text-h6 font-weight-bold text-center">
                {{ $t('HOME.title') }}
              </VCardTitle>

              <VCol cols="12">
                <div style="width: 100%;">
                  <VImg :src="computerPng" />
                </div>
              </VCol>

              <VCardText class="font-weight-light text-h6 mb-16 text-center" style="white-space: pre-line;">
                {{ $t('HOME.description') }}
              </VCardText>

              <VCardActions class="d-flex justify-center">
                <VBtn color="warning" @click="$emit('start_free')">
                  {{ $t('HOME.btn_gratis') }}
                </VBtn>

                <VBtn color="warning" variant="outlined" @click="$router.push('/contacts')">
                  {{ $t('HOME.btn_saber_mais') }}
                </VBtn>
              </VCardActions>
            </VCard>
          </VCol>

          <VCol cols="12">
            <VCard class="elevation-0" color="transparent" :rounded="0">
              <VCardText>
                <VCarousel :show-arrows="false" height="220">
                  <VCarouselItem v-for="(item, i) in items" :key="i">
                    <VImg :src="item.src" height="220" cover />
                  </VCarouselItem>
                </VCarousel>
              </VCardText>

              <VCardText class="text-body-1 font-weight-bold text-accent">
                {{ $t('HOME.designed_for') }}
              </VCardText>
            </VCard>
          </VCol>
        </VCol>
      </VRow>
    </VContainer>
  </div>
</template>

<script>
import heroImage from '@/assets/imgs/computer_edited.jpg'
import computerPng from '@/assets/imgs/computer.png'
import balloon from '@/assets/icons/examples/balloon.png'
import balloon2 from '@/assets/icons/examples/balloon2.png'
import balloon3 from '@/assets/icons/examples/balloon3.png'
import balloon4 from '@/assets/icons/examples/balloon4.png'

export default {
  name: 'HomeScreen',
  emits: ['start_free', 'saber-mais'],
  props: {
    screenSize: { type: Number, default: 0 }
  },
  data () {
    return {
      heroImage,      // ← agora disponível no template
      computerPng,    // ← evita "@/assets/..." direto no template
      items: [
        { src: balloon },
        { src: balloon2 },
        { src: balloon3 },
        { src: balloon4 }
      ]
    }
  },
  methods: {
    knowMore () {
      this.$emit('saber-mais')
    }
  }
}
</script>

<style>
body .linear-background{
  clip-path: polygon(0 0, 100% 0, 100% 97%, 0% 100%);
}
@media (min-width: 850px) {
  body .linear-background{
    clip-path: polygon(0 0, 100% 0, 100% 90%, 0% 100%);
  }
}

body #screen-background{
  background-image: url("../assets/imgs/computer.png");
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.object-contain { object-fit: contain; }
</style>
